<script setup lang="ts">
import { NButton, NEmpty, NImage } from '@nio-fe/lego';
const handleRefresh = () => {
  window.location.reload();
};
</script>

<template>
  <div class="overload-mask">
    <n-empty size="large" title="前方拥堵">
      <template #description>
        <h4>前方拥堵</h4>
        <p>哎呀~ 访问人数过多，请稍后重试</p>
      </template>
      <template #default>
        <n-button class="refresh-btn" @click="handleRefresh">刷新</n-button>
      </template>
      <template #image>
        <image
          width="160px"
          src="https://cdn-fx.nio.com/fx/nio-mate-web/__cdn__/icon-overload.png"
        />
      </template>
    </n-empty>
  </div>
</template>

<style scoped lang="scss">
.overload-mask {
  background: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  :deep(.n-empty__image) {
    display: flex;
    justify-content: center;
  }
  h4 {
    font-size: 20px;
    line-height: 30px;
    color: #040b29;
    margin-bottom: 8px;
  }
  .refresh-btn {
    width: 122px;
    margin-top: 16px;
  }
}
</style>
